import React, { ReactElement, useState } from 'react';
import { CourseActivity, RemoteOrganizer } from '../types';
import ActivityItem from '../activities/activity-item';

interface CatalogProps {
  title: string;
  organizers?: RemoteOrganizer[];
  activities: CourseActivity[];
}

// eslint-disable-next-line react/prop-types
export default function CatalogTypeItem({ title, organizers, activities }: CatalogProps): ReactElement {
  // eslint-disable-next-line react/prop-types
  const hasActivities = activities.length > 0;
  const [open, setOpen] = useState(false);
  const toggle = (): void => setOpen(!open);
  const activityItems =
    (open &&
      // eslint-disable-next-line react/prop-types
      activities.map((a) => (
        <ActivityItem
          key={a.id || a.courseId || a.title}
          id={a.id}
          title={a.title}
          description={a.description}
          organizer={a.organizer}
          type={a.type}
          date={a.date}
          time={a.time}
          day={a.day}
          requiresMembership={a.requiresMembership}
          isBookedUp={a.isBookedUp}
          allowsReserves={a.allowsReserves}
          imageUri={a.imageUri}
          link={a.link}
          organizers={organizers}
          activities={a.activities}
          isRegistrationOpen={a.isRegistrationOpen}
          url={a.url}
          bookable={a.bookable}
        />
      ))) ||
    [];
  let subMenuIcon;
  if (hasActivities) {
    subMenuIcon = (
      <div className="toggle-submenu">
        <div className="toggle-submenu-icon" />
      </div>
    );
  }
  return hasActivities ? (
    <li className={`menu-item ${hasActivities ? 'menu-item--has-children' : ''} ${open ? 'open' : ''}`}>
      <a onClick={toggle}>
        <span className="menu-item--link-inner">
          <span className="menu-item--link-hover">{title}</span>
        </span>
        {subMenuIcon}
      </a>
      <div className="sub-menu">
        <ul>{activityItems}</ul>
      </div>
    </li>
  ) : null;
}
CatalogTypeItem.displayName = 'CatalogTypeItem';
